var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"newsContainer"},[_c('first',{directives:[{name:"show",rawName:"v-show",value:(_vm.nowPage == 1),expression:"nowPage == 1"}],ref:"first",on:{"changePage":_vm.changePage}}),(_vm.nowPage == 2)?_c('second',{ref:"second",attrs:{"firstParams":_vm.firstParams},on:{"changePage2":_vm.changePage2,"issuseOk":_vm.issuseOk}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }